import { render, staticRenderFns } from "./matrixDetailTable.vue?vue&type=template&id=11b71af2&scoped=true&"
import script from "./matrixDetailTable.vue?vue&type=script&lang=js&"
export * from "./matrixDetailTable.vue?vue&type=script&lang=js&"
import style0 from "./matrixDetailTable.vue?vue&type=style&index=0&id=11b71af2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b71af2",
  null
  
)

export default component.exports